import TelephoneInput from './TelephoneInput'
import PinDots from './PinDots'

// Couleurs officielles Manrina
const MANRINA_COLORS = {
  orange: 'rgb(var(--c-primary))',
  vert: 'rgb(var(--c-green))',
  creme: 'rgb(var(--c-creme))',
}

// Etapes PIN
const PIN_STEP = {
  LOGIN: 'login',
  REGISTER: 'register',
}

// Mode immersif : etape telephone + etape PIN (connexion/inscription)
export default function ImmersivePinAuth({
  immersifStep,
  telephone,
  setTelephone,
  pin,
  setPin,
  pinConfirm,
  setPinConfirm,
  pinStep,
  setPinStep,
  prenom,
  setPrenom,
  nom,
  setNom,
  error,
  loading,
  handleImmersifNext,
  handleImmersifBack,
  handleCreateAccount,
  handleLoginPin,
  handleRegisterPin,
  setShowPinForgot,
  setPinForgotPhone,
  setPinForgotMessage,
  setPinForgotError,
  t,
}) {
  return (
    <>
      {/* ========== MODE IMMERSIF - ETAPE 1: TELEPHONE ========== */}
      {immersifStep === 1 && (
        <div className="space-y-6 animate-fadeIn">
          <div className="mb-2">
            <p className={`font-serif text-[22px] ${t.textPrimary}`}>Connexion</p>
            <p className={`text-sm ${t.textMuted} mt-1`}>Entrez votre numéro de téléphone pour continuer</p>
          </div>

          <TelephoneInput id="imm-telephone" value={telephone} onChange={setTelephone} t={t} autoFocus />

          {error && (
            <div className={`p-3 rounded-xl ${t.errorBg} text-sm text-center`}>
              {error}
            </div>
          )}

          <button
            type="button"
            onClick={() => { setPinStep(PIN_STEP.LOGIN); handleImmersifNext() }}
            disabled={!telephone || telephone.replace(/\D/g, '').length < 10}
            className="w-full py-4 rounded-full font-bold transition-all flex items-center justify-center gap-2 text-[15px]"
            style={(!telephone || telephone.replace(/\D/g, '').length < 10)
              ? { background: 'rgba(7,62,61,0.15)', color: 'rgba(7,62,61,0.4)' }
              : { background: 'linear-gradient(120deg, rgb(var(--c-primary)), #e0653a)', color: '#fff', boxShadow: '0 14px 32px rgba(244,137,83,0.4)' }}
          >
            Continuer
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <p className={`text-[11.5px] text-center ${t.textMuted}`}>
            Pas encore de compte ?{' '}
            <button
              type="button"
              onClick={handleCreateAccount}
              className="font-bold"
              style={{ color: 'rgb(var(--c-primary))' }}
            >
              Créer un compte
            </button>
          </p>
        </div>
      )}

      {/* ========== MODE IMMERSIF - ETAPE 2: PIN (login direct) ou INSCRIPTION ========== */}
      {immersifStep === 2 && (
        <div className="space-y-5 animate-fadeIn">
          {/* Info numéro + modifier (connexion : le numéro vient de l'etape 1) */}
          {pinStep === PIN_STEP.LOGIN && (
            <div className={`flex items-center justify-between p-3 rounded-xl ${t.tabBg}`}>
              <div className="flex items-center gap-2">
                <span className="text-lg">📱</span>
                <span className={t.textSecondary}>{telephone}</span>
              </div>
              <button
                type="button"
                onClick={handleImmersifBack}
                className={`text-xs font-semibold ${t.linkColor}`}
              >
                ‹ Modifier le numéro
              </button>
            </div>
          )}

          {/* Formulaire connexion PIN */}
          {pinStep === PIN_STEP.LOGIN && (
            <form onSubmit={handleLoginPin} className="space-y-4">
              <div>
                <p className={`font-serif text-[22px] ${t.textPrimary}`}>Votre code</p>
                <p className={`text-[12.5px] ${t.textMuted} mt-1 mb-4`}>Code PIN du {telephone}</p>
                <PinDots id="imm-pin" value={pin} onChange={setPin} t={t} autoFocus />
              </div>

              {error && (
                <div className={`p-3 rounded-xl ${t.errorBg} text-sm`}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading || pin.length < 6}
                className="w-full py-4 rounded-full text-white font-bold hover:opacity-90 disabled:opacity-40 transition-all flex items-center justify-center gap-2 text-[15px]"
                style={{ background: 'linear-gradient(120deg, rgb(var(--c-primary)), #e0653a)', boxShadow: '0 14px 32px rgba(244,137,83,0.4)' }}
              >
                {loading ? (
                  <span className="inline-block w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                ) : (
                  'Se connecter'
                )}
              </button>

              <button
                type="button"
                onClick={() => { setShowPinForgot(true); setPinForgotPhone(telephone); setPinForgotMessage(''); setPinForgotError('') }}
                className={`w-full text-center text-sm ${t.linkColor} mt-2`}
              >
                PIN oublie ? Faire une demande de reinitialisation
              </button>
            </form>
          )}

          {/* Formulaire inscription PIN */}
          {pinStep === PIN_STEP.REGISTER && (
            <form onSubmit={handleRegisterPin} className="space-y-4">
              <TelephoneInput id="imm-reg-tel" label="Téléphone" value={telephone} onChange={setTelephone} t={t} />

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label htmlFor="imm-prenom" className={`block text-xs font-medium ${t.textSecondary} mb-1`}>Prénom</label>
                  <input
                    id="imm-prenom"
                    type="text"
                    value={prenom}
                    onChange={(e) => setPrenom(e.target.value)}
                    placeholder="Marie"
                    required
                    className={`w-full px-3 py-2.5 rounded-xl ${t.inputBg} border ${t.inputBorder} ${t.inputFocus} ${t.inputText} outline-none transition backdrop-blur-sm`}
                  />
                </div>
                <div>
                  <label htmlFor="imm-nom" className={`block text-xs font-medium ${t.textSecondary} mb-1`}>Nom</label>
                  <input
                    id="imm-nom"
                    type="text"
                    value={nom}
                    onChange={(e) => setNom(e.target.value)}
                    placeholder="Dupont"
                    required
                    className={`w-full px-3 py-2.5 rounded-xl ${t.inputBg} border ${t.inputBorder} ${t.inputFocus} ${t.inputText} outline-none transition backdrop-blur-sm`}
                  />
                </div>
              </div>

              <div>
                <p className={`text-sm font-medium ${t.textSecondary} mb-1 text-center`}>Choisissez un code PIN</p>
                <PinDots id="imm-pin-register" value={pin} onChange={setPin} t={t}
                  aide="6 chiffres — c'est lui qui protégera votre compte" />
              </div>

              <div>
                <p className={`text-sm font-medium ${t.textSecondary} mb-1 text-center`}>Confirmez le code PIN</p>
                <PinDots id="imm-pin-confirm" value={pinConfirm} onChange={setPinConfirm} t={t}
                  aide={pinConfirm.length === 6 && pinConfirm !== pin ? '⚠️ Les deux codes ne correspondent pas' : 'Saisissez-le une seconde fois'} />
              </div>

              {error && (
                <div className={`p-3 rounded-xl ${t.errorBg} text-sm`}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading || !prenom || !nom || pin.length !== 6 || pinConfirm.length !== 6}
                className="w-full py-4 rounded-full text-white font-bold hover:opacity-90 disabled:opacity-40 transition-all flex items-center justify-center gap-2 text-[15px]"
                style={{ background: 'linear-gradient(120deg, rgb(var(--c-primary)), #e0653a)', boxShadow: '0 14px 32px rgba(244,137,83,0.4)' }}
              >
                {loading ? (
                  <span className="inline-block w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                ) : (
                  'Créer mon compte'
                )}
              </button>

              <button
                type="button"
                onClick={() => { setPinStep(PIN_STEP.LOGIN); handleImmersifBack() }}
                className={`w-full text-center text-sm ${t.linkColor} mt-1`}
              >
                J'ai déjà un compte — me connecter
              </button>
            </form>
          )}
        </div>
      )}
    </>
  )
}
